import React, { Component } from "react";

import SVG from "svg.js";

import s from "./SvgMapper.scss";

const uuidv4 = require("uuid/v4");

export default class SvgMapper extends Component {
  constructor(props) {
    super(props);
    this.svgParent = React.createRef();

    this.uuid = `svg-${uuidv4()}`;

    if (!props.ssr && window.XMLHttpRequest) {
      var ajax = new window.XMLHttpRequest();
      ajax.open("GET", `/mapper/${this.props.bgImage}`, true);
      ajax.send();
      ajax.onload = e => {
        let draw = SVG(this.uuid);

        draw.svg(ajax.responseText);

        let testSvg = draw.select("circle.cls-4");

        testSvg.mouseover(e => {
          if (e.target.id == "Dot-4" || e.target.id == "Dot-5") {
            document.querySelector("#multi-dot-1").classList.add("active");
          } else {

            e.target.parentNode.previousElementSibling.classList.add("active");
          }
        });
        testSvg.mouseout(e => {
          if (e.target.id == "Dot-4" || e.target.id == "Dot-5") {
            document.querySelector("#multi-dot-1").classList.remove("active");
          } else {
            e.target.parentNode.previousElementSibling.classList.remove("active");
          }
        });
        /*
        testSvg.click((e) => {
          !e.target.classList.contains('disabled') &&
          this.props.redirectTo && this.props.redirectTo('/budynek/'+e.target.id.replace('svg-building-', ''));
        });
*/
        this.props.active &&
          draw.select("#" + this.props.active).addClass("this");
      };
    }
  }



  render() {
    if (this.props.ssr) {
      return <span key={"key" + uuidv4()} />;
    }

    return (
      <div
        key={"key2" + uuidv4()}
        ref={this.svgParent}
        className="svg-mapper"
        id={this.uuid}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SvgMapper/SvgMapper.js